import type { Config } from "@App/configs/interfaces";

export const config: Partial<Config> = {
  slug: "arval",
  homeSections: {
    image: { src: "/images/partner/arval/arval_list_items.webp", alt: "Arval" },
  },
};

export default config;
